'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
require('prop-types');
var withStyles = require('../../Styles/withStyles.js');
var classNames = require('classnames');
var Button = require('./Button/Button.js');
var colorManipulator = require('../../../node_modules/@material-ui/core/esm/styles/colorManipulator.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var styles = function styles(theme) {
  return {
    root: {
      padding: '12px 16px',
      textTransform: 'none',
      boxShadow: 'none',
      borderRadius: 32,
      fontSize: 16,
      fontWeight: 400,
      '&:hover': {
        boxShadow: 'none'
      }
    },
    colorBrandPrimary: {
      background: theme.palette.brandPrimary.main,
      color: theme.palette.getContrastText(theme.palette.brandPrimary.main),
      '&:hover': {
        background: colorManipulator.fade(theme.palette.brandPrimary.main, 1 - theme.palette.action.hoverOpacity)
      },
      '&$focused': {
        background: colorManipulator.fade(theme.palette.brandPrimary.main, 1 - theme.palette.action.focusOpacity)
      },
      '& span': {
        '& svg': {
          color: theme.palette.getContrastText(theme.palette.brandPrimary.main)
        }
      }
    },
    outlinedBrandPrimary: {
      background: 'transparent',
      color: theme.palette.brandPrimary.main,
      border: "1px solid ".concat(colorManipulator.fade(theme.palette.brandPrimary.main, 0.4)),
      '&:hover': {
        background: colorManipulator.fade(theme.palette.secondary.light, theme.palette.action.hoverOpacity)
      },
      '&$focused': {
        background: colorManipulator.fade(theme.palette.secondary.light, theme.palette.action.focusOpacity)
      },
      '& span': {
        '& svg': {
          color: theme.palette.brandPrimary.main
        }
      }
    },
    input: {},
    focused: {}
  };
};

var PillButton = function PillButton(_ref) {
  var _classNames;

  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'contained' : _ref$variant,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'brandPrimary' : _ref$color,
      classes = _ref.classes,
      rest = objectWithoutProperties(_ref, ["variant", "color", "classes"]);

  return React__default["default"].createElement(Button["default"], _extends["default"]({
    size: "large",
    variant: variant,
    color: color === 'brandPrimary' ? 'default' : color,
    className: classNames__default["default"](classes.root, (_classNames = {}, defineProperty(_classNames, classes.colorBrandPrimary, color === 'brandPrimary'), defineProperty(_classNames, classes.outlinedBrandPrimary, variant === 'outlined' && color === 'brandPrimary'), _classNames))
  }, rest));
};

var PillButton$1 = withStyles["default"](styles)(PillButton);

module.exports = PillButton$1;
